enum ButtonVariant {
  Primary = 'Primary',
  Secondary = 'Secondary',
  Success = 'Success',
  Danger = 'Danger',
  Warning = 'Warning',
  Info = 'Info',
}

enum ButtonSizes {
  ExtraSmall = 'Xs',
  Small = 'Sm',
  Medium = 'Md',
  Large = 'Lg',
}

enum ButtonType {
  Button = 'button',
  Submit = 'submit',
  Reset = 'reset',
}

enum ButtonOpacity {
  Opacity75 = 'Opacity75',
  Opacity50 = 'Opacity50',
  Opacity25 = 'Opacity25',
}

enum ButtonColors {
  Red = 'Red',
  RedLighten = 'RedLighten',
  RedDarken = 'RedDarken',
  Blue = 'Blue',
  BlueLighten = 'BlueLighten',
  BlueDarken = 'BlueDarken',
  Green = 'Green',
  GreenLighten = 'GreenLighten',
  GreenDarken = 'GreenDarken',
  Yellow = 'Yellow',
  YellowLighten = 'YellowLighten',
  YellowDarken = 'YellowDarken',
  Grey = 'Grey',
  GreyLighten = 'GreyLighten',
  GreyDarken = 'GreyDarken',
}

export { ButtonSizes, ButtonType, ButtonVariant, ButtonOpacity, ButtonColors }
